import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  button: {
    minWidth: '100px',
  },
}));

export default useStyles;
